/*
  PDP behaviour — gallery, info disclosures, review tabs, artist bio, buy form + sticky bar.

  This was ~38 KB of inline <script> inside sections/main-product.liquid. Inline scripts block
  the HTML parser and are re-sent with every product page; the same code here is deferred (runs
  after the DOM exists) and cached across products.

  It is a plain .js asset, so NO Liquid runs in this file. Anything that used to be interpolated
  is read off <section data-pdp-section> instead. If you need a new Liquid value in here, add a
  data-* attribute to that element rather than moving the code back inline.
*/
(function () {
  var host = document.querySelector('[data-pdp-section]');
  if (!host) return;

  // `SID` reproduces the old `{{ section.id }}`, so every getElementById below resolves to
  // exactly the same element it did when this code was inline — the root stays the Shopify
  // section wrapper, not this inner <section>, which keeps the querySelector scopes unchanged.
  var SID = host.getAttribute('data-section-id') || '';
  var T = {
    bioMore:   host.getAttribute('data-bio-more')     || 'Read more',
    bioLess:   host.getAttribute('data-bio-less')     || 'Show less',
    addToCart: host.getAttribute('data-t-add')        || 'Add to basket',
    soldOut:   host.getAttribute('data-t-sold-out')   || 'Sold out'
  };

  /* ---------------------------------------------------------------- */

            (function () {
              var root = document.getElementById('shopify-section-' + SID);
              if (!root) return;
              var carousel = root.querySelector('[data-thumb-carousel]');
              var thumbs = carousel && carousel.querySelector('[data-thumbs]');
              if (!thumbs) return;

              // --- Thumbnail selection ---
              // Image thumbs swap the shared <img> src (and keep data-index in sync for the lightbox).
              // Video thumbs hide that <img>, reveal their own player in the main box and start it playing (see selectThumb).
              var mainImg = root.querySelector('[data-pdp-main-img]');
              var videoPanels = root.querySelectorAll('[data-pdp-video]');
              function stopVideos() {
                Array.prototype.forEach.call(videoPanels, function (p) {
                  var v = p.querySelector('video');
                  if (v) { try { v.pause(); } catch (e) {} }
                  var f = p.querySelector('iframe'); // external (YouTube/Vimeo): reload src to halt playback
                  if (f && f.src) { f.src = f.src; }
                });
              }
              // Swapping the main image is a network fetch (~335 KB), so it is NOT instant unless the
              // image was already warmed. Without feedback the page just sits on the previous photo
              // and the tap reads as broken. The spinner is deliberately delayed ~120 ms so a cached
              // swap — the common case once warming has run — shows nothing at all rather than a flash.
              var mainFrame = mainImg ? (mainImg.closest ? mainImg.closest('.main') : null) : null;
              var swapTimer = null;
              // Set while a swipe hand-off is in flight. The photo being swapped to is already
              // on screen in a peek by then, so a spinner would flash over a picture the
              // customer can see perfectly well.
              var quietSwap = false;
              // NB: `srcset` outranks `src`. Once the hero carries a srcset, assigning only
              // .src leaves the browser painting the ORIGINAL candidate forever — the thumbnail
              // appears to do nothing. Every swap must replace (or clear) the srcset too.
              function swapMainImage(url, index, srcset) {
                if (!mainImg || !url) return;
                clearTimeout(swapTimer);
                var settle = function () {
                  clearTimeout(swapTimer);
                  if (mainFrame) mainFrame.classList.remove('is-swapping');
                };
                if (!quietSwap) {
                  swapTimer = setTimeout(function () {
                    if (mainFrame) mainFrame.classList.add('is-swapping');
                  }, 120);
                }
                mainImg.addEventListener('load', settle, { once: true });
                mainImg.addEventListener('error', settle, { once: true });
                if (srcset) { mainImg.srcset = srcset; } else { mainImg.removeAttribute('srcset'); }
                mainImg.src = url;
                mainImg.setAttribute('data-index', index || '0');
                if (mainImg.complete) settle();
              }

              // `play` is only true for a real tap or click on a video thumbnail. The swipe hands off
              // through target.click(), which is untrusted, so swiping past a video leaves it on its poster.
              function selectThumb(btn, play) {
                stopVideos();
                if (btn.getAttribute('data-media-type') === 'video') {
                  var id = btn.getAttribute('data-media-id');
                  if (mainImg) mainImg.hidden = true;
                  Array.prototype.forEach.call(videoPanels, function (p) {
                    var show = p.getAttribute('data-media-id') === id;
                    p.hidden = !show;
                    var v = show && play ? p.querySelector('video') : null;
                    // Started inside the click itself, so the browser treats it as user-initiated. If it
                    // still refuses, the native controls are on screen to start it by hand.
                    if (v) { var started = v.play(); if (started && started.catch) started.catch(function () {}); }
                  });
                } else {
                  Array.prototype.forEach.call(videoPanels, function (p) { p.hidden = true; });
                  if (mainImg) {
                    mainImg.hidden = false;
                    swapMainImage(btn.getAttribute('data-full'), btn.getAttribute('data-index'), btn.getAttribute('data-srcset'));
                  }
                }
                Array.prototype.forEach.call(thumbs.querySelectorAll('.thumb'), function (t) { t.classList.remove('active'); });
                btn.classList.add('active');
              }
              thumbs.addEventListener('click', function (e) {
                var b = e.target.closest ? e.target.closest('.thumb') : null;
                if (b) selectThumb(b, e.isTrusted);
              });
              // Guard: make sure something is highlighted (e.g. a video-only product where no image thumb got `active`).
              if (!thumbs.querySelector('.thumb.active')) {
                var firstThumb = thumbs.querySelector('.thumb');
                if (firstThumb) firstThumb.classList.add('active');
              }

              // Warm the full-size (1200px) images on intent rather than on load.
              //
              // This used to prefetch EVERY thumbnail's `data-full` at window.load. On a 7-image
              // product that is ~2.8 MB pulled on every single page view, whether or not the
              // customer ever touches the gallery — measured as ~87% of the page's first-party
              // bytes in PageSpeed Insights. Warming on pointer/touch intent keeps the swap
              // feeling instant while costing nothing for the majority who never open it.
              var warmed = {};
              // Gallery images carry no srcset (see the note in sections/main-product.liquid), so
              // `data-full` IS the URL the swap will request and warming it is exact. The `ss`
              // branch below is kept as a guard: if a srcset is ever reintroduced, the throwaway
              // Image must mirror it or the browser resolves a different candidate and the
              // prefetch doubles the cost instead of hiding it.
              var warm = function (u, ss) {
                var key = ss || u;
                if (!key || warmed[key]) return;
                warmed[key] = true;
                var im = new Image();
                im.decoding = 'async';
                if (ss && mainImg) { im.sizes = mainImg.sizes; im.srcset = ss; }
                im.src = u;
              };
              // Skip entirely when the visitor has asked for reduced data, or is on a slow link.
              var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
              var thrifty = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));

              if (!thrifty) {
                Array.prototype.forEach.call(thumbs.querySelectorAll('[data-full]'), function (b) {
                  var fire = function () { warm(b.getAttribute('data-full'), b.getAttribute('data-srcset')); };
                  b.addEventListener('pointerenter', fire, { once: true, passive: true });
                  b.addEventListener('pointerdown', fire, { once: true, passive: true });
                  b.addEventListener('touchstart', fire, { once: true, passive: true });
                  b.addEventListener('focus', fire, { once: true });
                });

                // Sequential browsing stays smooth: whenever the main image changes, warm the
                // neighbour on each side so the next arrow press has it already.
                var warmNeighbours = function () {
                  var all = Array.prototype.slice.call(thumbs.querySelectorAll('[data-full]'));
                  var i = all.indexOf(thumbs.querySelector('.thumb.active'));
                  if (i < 0) i = 0;
                  [i + 1, i - 1].forEach(function (n) {
                    if (all[n]) warm(all[n].getAttribute('data-full'), all[n].getAttribute('data-srcset'));
                  });
                };
                thumbs.addEventListener('click', function () { setTimeout(warmNeighbours, 0); });

                // One image ahead, warmed while the browser is idle. Deliberately just ONE (~335 KB
                // at 900px): it makes the very first thumbnail tap feel instant, which is the tap
                // customers actually make, without restoring the ~2.3 MB that prefetching all seven
                // would cost. requestIdleCallback keeps it off the critical path entirely.
                var warmNext = function () {
                  var all = Array.prototype.slice.call(thumbs.querySelectorAll('[data-full]'));
                  var i = all.indexOf(thumbs.querySelector('.thumb.active'));
                  if (i < 0) i = 0;
                  if (all[i + 1]) warm(all[i + 1].getAttribute('data-full'), all[i + 1].getAttribute('data-srcset'));
                };
                if (window.requestIdleCallback) requestIdleCallback(warmNext, { timeout: 4000 });
                else setTimeout(warmNext, 2000);
              }

              // Carousel arrows — scroll the strip on its active axis (vertical beside the image,
              // horizontal under it on phones).
              var prev = carousel.querySelector('[data-thumb-prev]');
              var next = carousel.querySelector('[data-thumb-next]');
              var mainBox = root.querySelector('.gallery .main');
              // Must match the rail's media band in main-product.liquid exactly — if the two
              // drift apart the arrows scroll the wrong axis and the rail height goes uncapped.
              // The gap at 901-1150px is deliberate: the PDP is still two columns there, so the
              // gallery column is too narrow to give 86px away to a rail.
              var vmq = window.matchMedia('(min-width: 601px) and (max-width: 900px), (min-width: 1151px)');
              function vertical() { return vmq.matches; }
              // Side rail: cap it at the main image's height so a long thumbnail
              // list scrolls inside it; with only a few thumbs the rail stays its natural height.
              function syncRail() {
                if (vertical() && mainBox) {
                  thumbs.style.maxHeight = Math.round(mainBox.getBoundingClientRect().height) + 'px';
                } else {
                  thumbs.style.maxHeight = '';
                }
              }
              function maxScroll() { return vertical() ? (thumbs.scrollHeight - thumbs.clientHeight) : (thumbs.scrollWidth - thumbs.clientWidth); }
              function curPos() { return vertical() ? thumbs.scrollTop : thumbs.scrollLeft; }
              function update() {
                var max = maxScroll();
                if (max <= 1) { carousel.classList.add('no-nav'); return; }
                carousel.classList.remove('no-nav');
                if (prev) prev.disabled = curPos() <= 1;
                if (next) next.disabled = curPos() >= max - 1;
              }
              function refresh() { syncRail(); update(); }
              function step(dir) {
                var first = thumbs.querySelector('.thumb');
                var size = first ? (vertical() ? first.offsetHeight : first.offsetWidth) : 72;
                var amount = (size + 10) * dir;
                if (vertical()) thumbs.scrollBy({ top: amount, behavior: 'smooth' });
                else thumbs.scrollBy({ left: amount, behavior: 'smooth' });
              }
              if (prev) prev.addEventListener('click', function () { step(-1); });
              if (next) next.addEventListener('click', function () { step(1); });
              thumbs.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
              window.addEventListener('resize', function () { window.requestAnimationFrame(refresh); });
              if (vmq.addEventListener) vmq.addEventListener('change', refresh);
              refresh();
              setTimeout(refresh, 200);
              window.addEventListener('load', refresh);

              // --- Swipe (touch) ---
              // On mobile the thumbnail rail is a cramped afterthought, so the photo itself becomes
              // the control: flick left for the next item, right for the previous, and past the last
              // one it wraps round to the first (and backwards from the first to the last).
              //
              // Three elements move as ONE STRIP — whatever fills the frame (the shared <img>, or a
              // video panel) plus a `peek` parked exactly one frame width out on each side — so the
              // neighbour follows the finger in and the frame is never empty. Dragging the hero on
              // its own leaves blank frame behind it, which is what this replaced.
              //
              // Only three items are ever in flight, which keeps the intent-based loading above
              // intact: the peeks have no src until a finger lands, so a page view that never
              // touches the gallery still downloads exactly one photo.
              //
              // Navigation itself goes THROUGH the thumbnails (`target.click()`) rather than
              // calling swapMainImage directly, so the active-thumb state, the video handling and
              // the neighbour warm-up all keep working from one code path instead of two.
              var swipeThumbs = Array.prototype.slice.call(thumbs.querySelectorAll('.thumb'));
              var peekPrev = root.querySelector('[data-pdp-peek="prev"]');
              var peekNext = root.querySelector('[data-pdp-peek="next"]');
              if (swipeThumbs.length > 1 && mainImg && mainFrame && peekPrev && peekNext) {
                var galleryEl = root.querySelector('.gallery');
                if (galleryEl) galleryEl.classList.add('can-swipe'); // opts the <img> into touch-action: pan-y
                var calmMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
                var SWIPE_MIN = 40;   // px of horizontal travel before a flick counts as a swipe
                var GLIDE = 240;      // keep in step with the .is-gliding transition in the section CSS
                var CONTROLS_H = 56;  // native video control bar: its touches are its own, not ours
                var frameW = 0, busy = false, landTimer = null;
                var sx = 0, sy = 0, sdx = 0, tracking = false, dragged = false, eatClick = false;
                var movers = [mainImg].concat(Array.prototype.slice.call(videoPanels));

                function neighbour(dir) {
                  var i = swipeThumbs.indexOf(thumbs.querySelector('.thumb.active'));
                  if (i < 0) i = 0;
                  return swipeThumbs[(i + dir + swipeThumbs.length) % swipeThumbs.length];
                }
                function isVideoThumb(btn) { return !!btn && btn.getAttribute('data-media-type') === 'video'; }
                // Whatever is currently filling the frame. A video is as much a gallery item as a
                // photo, so it travels with the strip rather than being skipped over.
                function stage() {
                  if (mainImg && !mainImg.hidden) return mainImg;
                  for (var i = 0; i < videoPanels.length; i++) if (!videoPanels[i].hidden) return videoPanels[i];
                  return mainImg;
                }
                // Keep the rail in step with the item. Deliberately not scrollIntoView(): that
                // also scrolls every scrollable ancestor, i.e. it would yank the page around.
                function revealThumb(btn) {
                  if (!btn) return;
                  var cr = thumbs.getBoundingClientRect(), br = btn.getBoundingClientRect();
                  if (vertical()) {
                    if (br.top < cr.top) thumbs.scrollBy({ top: br.top - cr.top, behavior: 'smooth' });
                    else if (br.bottom > cr.bottom) thumbs.scrollBy({ top: br.bottom - cr.bottom, behavior: 'smooth' });
                  } else {
                    if (br.left < cr.left) thumbs.scrollBy({ left: br.left - cr.left, behavior: 'smooth' });
                    else if (br.right > cr.right) thumbs.scrollBy({ left: br.right - cr.right, behavior: 'smooth' });
                  }
                }
                // Points a peek at a thumbnail's media. It starts from the 200px thumbnail —
                // already decoded further down this very page, so the peek is never blank even on
                // the first flick — and upgrades to the full-size file as soon as that arrives,
                // usually straight from cache since warm() above prefetches these same URLs.
                // A video thumb has no full-size photo: its poster is all there is to show.
                function fillPeek(el, btn) {
                  if (!el || !btn) return;
                  var t = btn.querySelector('img');
                  var poster = t ? (t.currentSrc || t.src) : '';
                  var full = btn.getAttribute('data-full');
                  var ss = full ? btn.getAttribute('data-srcset') : null;
                  var key = ss || full || poster;
                  if (!key || el.getAttribute('data-peek-key') === key) return;
                  el.setAttribute('data-peek-key', key);
                  el.removeAttribute('srcset'); // srcset outranks src, so it must go before the stand-in
                  if (poster) el.src = poster;
                  if (!full) return;
                  var hi = new Image();
                  hi.decoding = 'async';
                  if (ss) { hi.sizes = mainImg.sizes; hi.srcset = ss; }
                  hi.src = full;
                  var apply = function () {
                    if (el.getAttribute('data-peek-key') !== key) return; // a later gesture won
                    if (ss) { el.sizes = mainImg.sizes; el.srcset = ss; }
                    el.src = full;
                  };
                  if (hi.complete) apply();
                  else hi.addEventListener('load', apply, { once: true });
                }
                // One frame width per item, so the gap between two photos is exactly the frame's
                // own padding — it reads as a carousel rather than as a picture on the move.
                function place(dx) {
                  var s = stage();
                  if (s) s.style.transform = 'translate3d(' + Math.round(dx) + 'px,0,0)';
                  peekPrev.style.transform = 'translate3d(' + Math.round(dx - frameW) + 'px,0,0)';
                  peekNext.style.transform = 'translate3d(' + Math.round(dx + frameW) + 'px,0,0)';
                }
                function endSwipe() {
                  clearTimeout(landTimer);
                  mainFrame.classList.remove('is-swiping');
                  mainFrame.classList.remove('is-gliding');
                  mainFrame.classList.remove('is-swapping');
                  for (var i = 0; i < movers.length; i++) if (movers[i]) movers[i].style.transform = '';
                  peekPrev.style.transform = '';
                  peekNext.style.transform = '';
                  busy = false;
                }
                // Not far enough to count: glide the strip back to where it started.
                function cancel() {
                  if (!mainFrame.classList.contains('is-swiping')) { busy = false; return; }
                  busy = true;
                  mainFrame.classList.add('is-gliding');
                  place(0);
                  clearTimeout(landTimer);
                  landTimer = setTimeout(endSwipe, GLIDE + 20);
                }
                // The hero <img> keeps painting the PREVIOUS photo until the new file decodes, so
                // uncovering it early is what made a slow photo look like it "jumped back" one.
                // (Shopify generates each CDN derivative on first request — the very first view of
                // a width can take seconds.) Instead the peek that just glided into the centre
                // stays put as a cover, showing this same photo at thumbnail resolution, and is
                // only dropped once the hero has really decoded. Nothing moves at the hand-off,
                // so there is nothing to see whether that takes 5 ms or 5 s.
                function waitForHero(cover) {
                  var settled = false;
                  var slow = setTimeout(function () { mainFrame.classList.add('is-swapping'); }, 500);
                  var finish = function (ok) {
                    if (settled) return;
                    settled = true;
                    clearTimeout(slow);
                    mainFrame.classList.remove('is-swapping');
                    if (tracking || busy) return; // a new gesture owns the strip now
                    // A photo that never arrived at all: keep the cover up. Uncovering would show
                    // the hero still painting the PREVIOUS photo, and the wrong picture is worse
                    // than the right one at thumbnail resolution.
                    if (ok === false || !mainImg.naturalWidth) return;
                    endSwipe();
                    fillPeek(peekPrev, neighbour(-1));
                    fillPeek(peekNext, neighbour(1));
                  };
                  var ok = function () { finish(true); }, bad = function () { finish(false); };
                  var d = mainImg.decode ? mainImg.decode() : null;
                  if (d && d.then) d.then(ok, bad);
                  else if (mainImg.complete) finish(mainImg.naturalWidth > 0);
                  else {
                    mainImg.addEventListener('load', ok, { once: true });
                    mainImg.addEventListener('error', bad, { once: true });
                  }
                  setTimeout(bad, 15000); // last resort: never leave the strip parked for ever
                }
                function land(target, dir, cover) {
                  mainFrame.classList.remove('is-gliding'); // nothing below this line may animate
                  quietSwap = true;
                  target.click();  // the normal swap path: media, active thumb, warming
                  revealThumb(target);
                  quietSwap = false;
                  // Re-centre WITHOUT moving the cover: it is already at the centre showing this
                  // very item, so it hides whatever the hero has not painted yet.
                  place(0);
                  cover.style.transform = 'translate3d(0,0,0)';
                  busy = false; // the customer may carry on swiping
                  if (isVideoThumb(target)) { endSwipe(); return; } // a player took the frame: nothing to decode
                  waitForHero(cover);
                }
                function go(dir) {
                  var target = neighbour(dir);
                  if (!target) { cancel(); return; }
                  var cover = dir > 0 ? peekNext : peekPrev;
                  if (calmMQ.matches) { endSwipe(); target.click(); revealThumb(target); return; }
                  busy = true;
                  mainFrame.classList.add('is-gliding');
                  place(-dir * frameW);
                  clearTimeout(landTimer);
                  landTimer = setTimeout(function () { land(target, dir, cover); }, GLIDE + 20);
                }

                mainFrame.addEventListener('touchstart', function (e) {
                  // A new gesture means the compensating click of the previous one has already
                  // been and gone; keeping the guard armed would swallow THIS tap instead.
                  eatClick = false;
                  if (busy || e.touches.length !== 1) { tracking = false; return; }
                  // A video's own control bar owns the bottom of the frame — scrubbing must not
                  // be read as a flick. The rest of the player is fair game, so a video can be
                  // swiped away from just like a photo.
                  if (mainImg.hidden) {
                    var fr = mainFrame.getBoundingClientRect();
                    if (e.touches[0].clientY > fr.bottom - CONTROLS_H) { tracking = false; return; }
                  }
                  // Normalise anything a previous hand-off left parked (a very slow photo).
                  if (mainFrame.classList.contains('is-swiping')) endSwipe();
                  tracking = true; dragged = false; sdx = 0;
                  sx = e.touches[0].clientX; sy = e.touches[0].clientY;
                  // clientWidth = the padding box, which is exactly how wide each peek is, so
                  // one step of frameW leaves a gap of precisely the frame's own padding.
                  frameW = mainFrame.clientWidth || mainFrame.offsetWidth || 320;
                  // Load on intent, exactly like the thumbnail warm-up above.
                  fillPeek(peekPrev, neighbour(-1));
                  fillPeek(peekNext, neighbour(1));
                }, { passive: true });

                mainFrame.addEventListener('touchmove', function (e) {
                  if (!tracking) return;
                  var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
                  // Vertical intent wins: the customer is scrolling the page, not browsing photos.
                  if (!dragged && Math.abs(dy) > Math.abs(dx)) { tracking = false; return; }
                  if (!dragged && Math.abs(dx) < 6) return; // ignore the jitter of a plain tap
                  if (!dragged) {
                    dragged = true;
                    // Class and transform in one go: the peeks become visible in the same style
                    // recalculation that moves them out of the frame, so they never flash at centre.
                    mainFrame.classList.add('is-swiping');
                  }
                  sdx = dx;
                  place(dx); // 1:1 with the finger, neighbours carried along
                }, { passive: true });

                mainFrame.addEventListener('touchend', function () {
                  if (!tracking) return;
                  tracking = false;
                  if (!dragged) return;
                  // `touch-action: pan-y` means a horizontal drag is NOT a scroll, so the browser
                  // still fires a click at the end of it — which would open the zoom lightbox on
                  // top of the photo just swiped to. Swallow that one click (below).
                  eatClick = true;
                  setTimeout(function () { eatClick = false; }, 400);
                  if (Math.abs(sdx) >= SWIPE_MIN) go(sdx < 0 ? 1 : -1);
                  else cancel();
                }, { passive: true });

                mainFrame.addEventListener('touchcancel', function () {
                  tracking = false;
                  if (dragged) cancel();
                  dragged = false;
                }, { passive: true });

                mainFrame.addEventListener('click', function (e) {
                  if (!eatClick) return;
                  eatClick = false;
                  e.stopPropagation();
                  e.preventDefault();
                }, true); // capture: stops the event before it reaches the <img> zoom trigger
              }
            })();
          

  /* ---------------------------------------------------------------- */

        (function(){
          var wrap = document.getElementById('pdp-disc-' + SID);
          if (!wrap) return;
          /* Customer reviews: a button-driven accordion in the info column — not a <details>, see the section markup */
          wrap.querySelectorAll('[data-disc-toggle]').forEach(function(btn){
            btn.addEventListener('click', function(){
              var sec = btn.closest('[data-disc]');
              var open = sec.classList.toggle('is-open');
              btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
          });

          /* Clicking the star badge under the title should jump to the reviews.
             Judge.me only scrolls when jQuery sees the widget as visible
             (`.jdgm-review-widget:visible` filtered by computed visibility !== 'hidden'), and it
             can only open panes it recognises — an <a> or an `li.tab__item` whose text reads
             "Customer reviews"/"Reviews". Ours is a collapsed accordion on mobile, opened by a
             <button>, so it matched nothing and the badge click did nothing there. */
          var revPane = wrap.querySelector('[data-pane="reviews"]');
          var section = document.getElementById('shopify-section-' + SID);
          var badge = section && section.querySelector('.pdp-jdgm-badge');
          if (revPane && badge) {
            var revDisc = revPane.closest('[data-disc]');
            var revToggle = revDisc && revDisc.querySelector('[data-disc-toggle]');
            badge.addEventListener('click', function(){
              /* only when the toggle is actually on screen — a hidden toggle means an always-open pane */
              var accordion = revToggle && getComputedStyle(revToggle).display !== 'none';
              if (accordion && !revDisc.classList.contains('is-open')) revToggle.click();
              /* Do the scrolling ourselves. Judge.me's runs through a jQuery fx queue that
                 intermittently never fired once the pane had just opened, and it targets
                 widget-top minus a hard-coded 30px — which tucks the top of the widget under our
                 sticky header. `jdgmSettings.scrollTo` is Judge.me's own veto hook: returning
                 false cancels their animation and leaves the scroll to us. */
              if (window.jdgmSettings) {
                var prevHook = jdgmSettings.scrollTo;
                jdgmSettings.scrollTo = function(){ return false; };
                setTimeout(function(){ jdgmSettings.scrollTo = prevHook; }, 2000);
              }
              /* Measured synchronously — opening the pane expands it downwards, so the target's
                 own top does not move. (Deliberately not in requestAnimationFrame: rAF is paused
                 whenever the page isn't being rendered, which silently swallowed the scroll.) */
              var target = accordion ? revDisc : wrap;
              var offset = 0;
              document.querySelectorAll('.shopify-section-group-header-group').forEach(function(el){
                var pos = getComputedStyle(el).position;
                if (pos === 'sticky' || pos === 'fixed') offset = Math.max(offset, el.getBoundingClientRect().bottom);
              });
              window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 12, behavior: 'smooth' });
            }, true);
          }

          /* Phones: only the first N reviews (data-rev-visible) show; the rest fade out behind
             "Read more reviews", like the artist bio. The wrapper is clipped at the top of review N+1
             plus a small peek — clipped, never display:none, because Judge.me measures each review's
             text on mount to decide on its own "More" link. Judge.me renders late, re-renders on sort,
             filter and paging, and its "More" and lazy photos change heights, so the clip is
             re-measured on DOM and size changes rather than once. */
          (function(){
            var clip = wrap.querySelector('[data-rev-clip]');
            var toggle = wrap.querySelector('[data-rev-toggle]');
            if (!clip || !toggle) return;
            var visible = parseInt(clip.getAttribute('data-rev-visible'), 10) || 0;
            if (visible < 1) return;
            var label = toggle.querySelector('[data-rev-label]');
            var PEEK = 56; /* keep in step with the .pdp-rev-clip::after height in the section CSS */
            var phone = window.matchMedia('(max-width: 600px)');
            var expanded = false, timer = null;
            function measure(){
              var items = clip.querySelectorAll('.jdgm-review-list .jm-review-item');
              var cut = phone.matches && items.length > visible ? items[visible] : null;
              toggle.hidden = !cut;
              if (!cut || expanded) { clip.classList.remove('is-clamped'); return; }
              var h = cut.getBoundingClientRect().top - clip.getBoundingClientRect().top + PEEK;
              clip.style.setProperty('--rev-clip', Math.round(h) + 'px');
              clip.classList.add('is-clamped');
            }
            function later(){ clearTimeout(timer); timer = setTimeout(measure, 60); }
            toggle.addEventListener('click', function(){
              expanded = !expanded;
              toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
              if (label) label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more') || '';
              measure();
              /* Collapsing a long list can leave the reader far below the button — bring it back. */
              if (!expanded && toggle.getBoundingClientRect().top < 0) toggle.scrollIntoView({ block: 'center' });
            });
            if ('MutationObserver' in window) new MutationObserver(later).observe(clip, { childList: true, subtree: true });
            var widget = clip.querySelector('#judgeme_product_reviews');
            if (widget && 'ResizeObserver' in window) new ResizeObserver(later).observe(widget);
            if (phone.addEventListener) phone.addEventListener('change', later);
            measure();
          })();
        })();
      

  /* ---------------------------------------------------------------- */

      /* The jump link under the short description. It is a real <a href="#...">, so the no-JS
         path already works; this only fixes the two things a bare anchor cannot do: land the
         heading clear of the sticky header, and open the target when the merchant has set that
         section to start closed — jumping to a collapsed <details> otherwise shows nothing but
         its own title, which looks like a broken link. */
      (function () {
        var root = document.getElementById('shopify-section-' + SID);
        if (!root) return;
        root.querySelectorAll('[data-pdp-jump]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            var id = (link.getAttribute('href') || '').slice(1);
            if (!id) return;
            var target = document.getElementById(id);
            if (!target) return;
            e.preventDefault();
            /* Opened before measuring on purpose: a <details> expands downwards, so its own top
               does not move and the offset stays correct. */
            if (target.tagName === 'DETAILS' && !target.open) target.open = true;
            var offset = 0;
            document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
              var pos = getComputedStyle(el).position;
              if (pos === 'sticky' || pos === 'fixed') offset = Math.max(offset, el.getBoundingClientRect().bottom);
            });
            window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 12, behavior: 'smooth' });
            if (history.replaceState) history.replaceState(null, '', '#' + id);
          });
        });
      })();

  /* ---------------------------------------------------------------- */

      (function () {
        var root = document.getElementById('shopify-section-' + SID);
        if (!root) return;
        var car = root.querySelector('[data-obt-carousel]');
        if (!car) return;
        var track = car.querySelector('[data-obt-track]');
        var prev = car.querySelector('[data-obt-prev]');
        var next = car.querySelector('[data-obt-next]');
        if (!track || !prev || !next) return;
        function update() {
          var maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll <= 1) {
            prev.setAttribute('disabled', '');
            next.setAttribute('disabled', '');
            return;
          }
          if (track.scrollLeft <= 1) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled');
          if (track.scrollLeft >= maxScroll - 1) next.setAttribute('disabled', ''); else next.removeAttribute('disabled');
        }
        function step(dir) {
          var first = track.querySelector('.kit');
          var amount = first ? (first.getBoundingClientRect().width + 12) : (track.clientWidth * 0.8);
          track.scrollBy({ left: dir * amount, behavior: 'smooth' });
        }
        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
        window.addEventListener('resize', function () { window.requestAnimationFrame(update); });
        update();
        setTimeout(update, 200);
        window.addEventListener('load', update);

        // ── Bundle: running total + "add the whole set" ──
        var bundle = root.querySelector('[data-obt-bundle]');
        if (bundle) {
          var totalEl = bundle.querySelector('[data-obt-total]');
          var addBtn = bundle.querySelector('[data-obt-add-set]');
          function items() {
            return Array.prototype.slice.call(track.querySelectorAll('[data-obt-item]'));
          }
          function available() {
            return items().filter(function (it) { return !it.hasAttribute('data-sold-out'); });
          }
          function checked() {
            return available().filter(function (it) {
              var cb = it.querySelector('[data-obt-check]');
              return cb && cb.checked;
            });
          }
          function money(cents) {
            var sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD') ? '$' : '£';
            return sym + (cents / 100).toFixed(2);
          }
          function refresh() {
            var sel = checked();
            var total = sel.reduce(function (s, it) { return s + (parseInt(it.getAttribute('data-price'), 10) || 0); }, 0);
            if (totalEl) totalEl.textContent = money(total);
            if (!addBtn) return;
            if (sel.length === 0) {
              addBtn.disabled = true;
              addBtn.textContent = addBtn.getAttribute('data-label-empty') || 'Select items to add';
            } else if (sel.length === available().length) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.getAttribute('data-label-all') || 'Add the whole set';
            } else {
              addBtn.disabled = false;
              addBtn.textContent = 'Add ' + sel.length + (sel.length === 1 ? ' item' : ' items');
            }
          }
          track.addEventListener('change', function (e) {
            if (e.target && e.target.matches('[data-obt-check]')) refresh();
          });
          if (addBtn) {
            addBtn.addEventListener('click', function () {
              var payload = checked().map(function (it) {
                return { id: parseInt(it.getAttribute('data-variant-id'), 10), quantity: 1 };
              }).filter(function (l) { return l.id; });
              if (!payload.length) return;
              if (window.TP && typeof window.TP.addItems === 'function') {
                window.TP.addItems(payload, addBtn);
              }
            });
          }
          refresh();
        }
      })();
    

  /* ---------------------------------------------------------------- */

    (function () {
      var root = document.getElementById('shopify-section-' + SID);
      if (!root) return;

      /*
        The info-column disclosures (Details, Delivery & Returns, FAQ, About this piece, About the
        artist) used to be pinned open and made non-clickable above 600px by JS. They are now
        plain <details> at every width, each starting open or closed per its Customiser setting
        via the `open` attribute in the markup, so no script is involved. Customer reviews is
        the exception — see the disc code above.
      */

      /*
        Artist bio "Read more". The markup arrives clamped; this only decides which bios are
        long enough to deserve the button and unclamps the rest. Runs before the lightbox code
        below, which bails early on products with no images.
      */
      (function () {
        var bios = root.querySelectorAll('[data-bio]');
        if (!bios.length) return;
        var MORE = T.bioMore;
        var LESS = T.bioLess;

        function measure(bio) {
          var clip = bio.querySelector('[data-bio-clip]');
          var btn = bio.querySelector('[data-bio-toggle]');
          if (!clip || !btn) return;
          /* Leave a bio the reader has opened alone — re-clamping it under them would be rude. */
          if (btn.getAttribute('aria-expanded') === 'true') return;
          /* Re-apply the clamp before measuring: an unclamped bio reports scrollHeight ===
             clientHeight, so without this a bio that fits at desktop width could never
             re-clamp when the window narrows and the text reflows onto more lines. */
          bio.classList.add('is-clamped');
          /* Inside a collapsed <details> every height reads 0 — that is "unmeasurable",
             not "fits", so leave it clamped and wait for the toggle listener below. */
          if (!clip.clientHeight) return;
          var overflows = clip.scrollHeight - clip.clientHeight > 4;
          if (!overflows) bio.classList.remove('is-clamped');
          btn.hidden = !overflows;
        }

        function measureAll() { Array.prototype.forEach.call(bios, measure); }

        Array.prototype.forEach.call(bios, function (bio) {
          var btn = bio.querySelector('[data-bio-toggle]');
          var label = bio.querySelector('[data-bio-label]');
          if (!btn) return;
          btn.addEventListener('click', function () {
            var expanded = !bio.classList.toggle('is-clamped');
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (label) label.textContent = expanded ? LESS : MORE;
          });
        });

        measureAll();
        /* Web fonts land after first paint and change how the text wraps, so measure again. */
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAll);
        var rt;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measureAll, 150); });
        var pane = root.querySelector('[data-pane="artist"]');
        var det = pane && pane.closest('details');
        if (det) det.addEventListener('toggle', measureAll);
      })();

      /* Image lightbox / zoom */
      var box = root.querySelector('[data-pdp-lightbox]');
      var trigger = root.querySelector('[data-pdp-zoom]');
      if (!box || !trigger) return;

      /* Portal the lightbox to <body>. It is rendered inside the section, but <main> is a
         stacking context (`main, header, footer { position: relative; z-index: 1 }`) and the
         sticky header group is a SIBLING of <main> at z-index 50 — so the lightbox's z-index
         200 was trapped underneath it and the header covered the backdrop, the top of the
         image and the close button. Every other overlay in this theme (cart-drawer,
         quick-add-drawer) already lives at body level after </main>; this matches that.
         Done at init rather than in open() so it runs once and stays idempotent. A stale copy
         can be left behind when the section re-renders in the theme editor, so clear it first. */
      var stale = document.querySelector('body > [data-pdp-lightbox]');
      if (stale && stale !== box) stale.remove();
      if (box.parentNode !== document.body) document.body.appendChild(box);

      var imgEl = box.querySelector('[data-lb-img]');
      var btnClose = box.querySelector('[data-lb-close]');
      var btnPrev = box.querySelector('[data-lb-prev]');
      var btnNext = box.querySelector('[data-lb-next]');
      var imagesScript = root.querySelector('[data-pdp-images]');
      var images = [];
      try { images = JSON.parse(imagesScript.textContent); } catch (e) {}
      if (!images.length) return;
      var idx = 0;
      var single = images.length < 2;
      if (single) { if (btnPrev) btnPrev.hidden = true; if (btnNext) btnNext.hidden = true; }

      /* Zoom + pan.
         The previous version scaled the photo and then re-pointed `transform-origin` at the
         cursor on every `mousemove`. Two things were wrong with that, both measured on the live
         PDP on 2026-09-15:
           - Touch had no pan at all. `mousemove` never fires on a phone, and the swipe handler
             below deliberately stands down while zoomed, so an eight-step drag left the origin
             on 179.406px — byte-identical to where the tap put it.
           - On desktop it only converged by feedback, because the origin was computed from
             getBoundingClientRect() of the ALREADY-SCALED image. Each event closed half the
             remaining gap, so the pan trailed the cursor and froze wherever the cursor stopped:
             a sweep to x=400 settled on 135.8px where 76px was correct, which is why the edges
             of the photo could never be reached.
         A translate the pointer drags fixes both, and Pointer Events give mouse, pen and touch
         one code path. */
      var ZOOM = 2, tx = 0, ty = 0;
      var panId = null, panX = 0, panY = 0, panMoved = false;

      function applyTransform() {
        imgEl.style.transform = box.classList.contains('zoomed')
          ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + ZOOM + ')'
          : '';
      }
      /* offsetWidth/offsetHeight are layout values and ignore transforms, so the un-zoomed size
         stays readable while the image is scaled — no need to cache it on zoom-in. Clamped to
         the viewport so the photo can never be dragged off into empty space. */
      function clampPan() {
        var mx = Math.max(0, (imgEl.offsetWidth * ZOOM - window.innerWidth) / 2);
        var my = Math.max(0, (imgEl.offsetHeight * ZOOM - window.innerHeight) / 2);
        tx = Math.min(mx, Math.max(-mx, tx));
        ty = Math.min(my, Math.max(-my, ty));
      }
      function resetZoom() {
        box.classList.remove('zoomed', 'is-panning');
        tx = ty = 0;
        /* panMoved is otherwise only cleared on pointerdown, which stands down while un-zoomed —
           so a drag followed by a close left it set, and the first zoom-IN click on the next
           opening was swallowed as "the end of a drag". */
        panMoved = false;
        imgEl.style.transform = '';
      }
      function zoomAt(clientX, clientY) {
        var r = imgEl.getBoundingClientRect(); // still un-scaled on the way in
        /* Hold the tapped point still: a point `p` away from the centre lands at p * ZOOM + t,
           so t = p * (1 - ZOOM) leaves it exactly where the finger was. */
        tx = (clientX - (r.left + r.width / 2)) * (1 - ZOOM);
        ty = (clientY - (r.top + r.height / 2)) * (1 - ZOOM);
        box.classList.add('zoomed');
        clampPan();
        applyTransform();
      }

      imgEl.addEventListener('pointerdown', function (e) {
        if (!box.classList.contains('zoomed')) return; // un-zoomed, the swipe handler owns the gesture
        panId = e.pointerId; panX = e.clientX; panY = e.clientY; panMoved = false;
        box.classList.add('is-panning');
        /* Capture, so a drag survives the pointer crossing the close button, which sits above the
           photo at z-index 2 and would otherwise swallow the rest of the movement. */
        if (imgEl.setPointerCapture) { try { imgEl.setPointerCapture(e.pointerId); } catch (err) {} }
        e.preventDefault(); // also stops the browser's native image drag-and-drop on desktop
      });
      imgEl.addEventListener('pointermove', function (e) {
        if (panId === null || e.pointerId !== panId) return;
        var dx = e.clientX - panX, dy = e.clientY - panY;
        if (!panMoved && Math.abs(dx) + Math.abs(dy) > 4) panMoved = true;
        panX = e.clientX; panY = e.clientY;
        tx += dx; ty += dy;
        clampPan();
        applyTransform();
      });
      function endPan(e) {
        if (panId === null || (e && e.pointerId !== panId)) return;
        if (imgEl.releasePointerCapture) { try { imgEl.releasePointerCapture(panId); } catch (err) {} }
        panId = null;
        box.classList.remove('is-panning');
      }
      imgEl.addEventListener('pointerup', endPan);
      imgEl.addEventListener('pointercancel', endPan);
      imgEl.addEventListener('dragstart', function (e) { e.preventDefault(); });

      imgEl.addEventListener('click', function (e) {
        e.stopPropagation();
        // Every drag ends in a click; that one must not read as "toggle the zoom back off".
        if (panMoved) { panMoved = false; return; }
        if (box.classList.contains('zoomed')) resetZoom();
        else zoomAt(e.clientX, e.clientY);
      });

      // A rotate or a resize can leave the photo parked outside the new viewport.
      window.addEventListener('resize', function () {
        if (!box.classList.contains('zoomed')) return;
        clampPan(); applyTransform();
      });

      function show(i) {
        idx = (i + images.length) % images.length;
        imgEl.src = images[idx];
        resetZoom();
      }
      function open(i) {
        show(i);
        box.classList.add('is-open');
        box.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      function close() {
        box.classList.remove('is-open');
        resetZoom();
        box.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }

      trigger.addEventListener('click', function () { open(parseInt(trigger.dataset.index, 10) || 0); });
      if (btnClose) btnClose.addEventListener('click', close);
      if (btnPrev) btnPrev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      if (btnNext) btnNext.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      box.addEventListener('click', function (e) { if (e.target === box) close(); });

      // Swipe the fullscreen view too — tapping a photo on mobile lands you here, and the two
      // tiny arrows are a poor target. show() is already modulo-based, so it wraps for free.
      // No finger-follow here: .lb-img's transform belongs to the zoom, and driving both would
      // leave a half-panned photo behind when the zoom is released.
      (function () {
        var lx = 0, ly = 0, ldx = 0, lTracking = false, lMoved = false, lEat = false;
        box.addEventListener('touchstart', function (e) {
          lEat = false; // see the gallery swipe above: a new gesture disarms the stale guard
          if (single || e.touches.length !== 1 || box.classList.contains('zoomed')) { lTracking = false; return; }
          lTracking = true; lMoved = false; ldx = 0;
          lx = e.touches[0].clientX; ly = e.touches[0].clientY;
        }, { passive: true });
        box.addEventListener('touchmove', function (e) {
          if (!lTracking) return;
          var dx = e.touches[0].clientX - lx, dy = e.touches[0].clientY - ly;
          if (!lMoved && Math.abs(dy) > Math.abs(dx)) { lTracking = false; return; }
          if (Math.abs(dx) > 6) { lMoved = true; ldx = dx; }
        }, { passive: true });
        box.addEventListener('touchend', function () {
          if (!lTracking) return;
          lTracking = false;
          if (!lMoved || Math.abs(ldx) < 40) return;
          lEat = true;
          setTimeout(function () { lEat = false; }, 400);
          show(ldx < 0 ? idx + 1 : idx - 1);
        }, { passive: true });
        // The click that follows the gesture would otherwise read as tap-to-zoom (on the photo)
        // or tap-the-backdrop-to-close (off it). Caught on `document` rather than on `box`,
        // because a listener on box cannot pre-empt box's own close handler — at the target,
        // listeners run in registration order whatever their capture flag says.
        document.addEventListener('click', function (e) {
          if (!lEat) return;
          lEat = false;
          if (!box.contains(e.target)) return;
          e.stopPropagation();
          e.preventDefault();
        }, true);
      })();

      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft' && !single) show(idx - 1);
        else if (e.key === 'ArrowRight' && !single) show(idx + 1);
      });
    })();
  

  /* ---------------------------------------------------------------- */

    (function () {
      var root = document.getElementById('shopify-section-' + SID);
      if (!root) return;
      var form = root.querySelector('form[data-pdp-form]');
      // Coming-soon PDPs render the waitlist block INSTEAD of the cart form, so `form` is null there.
      // Bailing out on that would also skip the sticky-bar logic further down, which the waitlist
      // still needs — hence carry on when either one is present and null-guard the form reads below.
      // (`form ? x : null` is identical to `x` whenever form exists, so normal PDPs are untouched.)
      var notifyBlock = root.querySelector('[data-notify-block]');
      if (!form && !notifyBlock) return;
      var mainBtn = form ? form.querySelector('button[type="submit"]') : null;
      var hiddenId = form ? form.querySelector('input[name="id"]') : null;
      var mainOptionInputs = form ? form.querySelectorAll('input[type="radio"][data-pdp-option-index]') : [];
      var mainQty = form ? form.querySelector('input[name="quantity"]') : null;
      var mainPriceEl = root.querySelector('.buy .price');
      var mainCompareEl = root.querySelector('.buy .compare');
      var mainCompareWrap = root.querySelector('[data-pdp-compare-wrap]');
      var saleBadgeEl = root.querySelector('[data-pdp-sale-badge]');

      var bar = root.querySelector('[data-pdp-sticky]');
      var stickyBtn = bar && (bar.querySelector('[data-pdp-sticky-add]') || bar.querySelector('[data-notify-scroll]'));
      var stickyPriceEl = bar && bar.querySelector('[data-pdp-sticky-price]');
      var stickyOptionSelects = bar ? bar.querySelectorAll('select[data-pdp-sticky-option]') : [];
      var stickyQty = bar && bar.querySelector('[data-pdp-sticky-qty]');

      var variantsScript = root.querySelector('[data-pdp-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}

      var addLabel = T.addToCart;
      var soldOutLabel = T.soldOut;

      function readMainOptions() {
        var out = [];
        Array.prototype.forEach.call(mainOptionInputs, function (r) {
          if (r.checked) out[parseInt(r.dataset.pdpOptionIndex, 10)] = r.value;
        });
        return out;
      }
      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < v.options.length; j++) {
            if (v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }
      function syncSelectsFromMain() {
        var opts = readMainOptions();
        Array.prototype.forEach.call(stickyOptionSelects, function (s) {
          var idx = parseInt(s.dataset.pdpOptionIndex, 10);
          if (s.value !== opts[idx]) s.value = opts[idx];
        });
      }
      function applyVariant() {
        var opts = readMainOptions();
        var v = findVariant(opts);
        if (!v) return;
        if (hiddenId) hiddenId.value = v.id;
        if (mainPriceEl) mainPriceEl.textContent = v.price_formatted;
        var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
        if (mainCompareEl && onSale) mainCompareEl.textContent = v.compare_at_price_formatted;
        if (mainCompareWrap) mainCompareWrap.hidden = !onSale;
        if (saleBadgeEl) saleBadgeEl.hidden = !onSale;
        if (stickyPriceEl) stickyPriceEl.textContent = v.price_formatted;
        if (mainBtn) {
          mainBtn.disabled = !v.available;
          if (v.available) {
            // Same markup as the Liquid render — the price span is hidden on phones.
            var labelEl = document.createElement('span');
            labelEl.className = 'btn-label';
            labelEl.textContent = addLabel;
            var priceEl = document.createElement('span');
            priceEl.className = 'btn-price';
            priceEl.textContent = ' · ' + v.price_formatted;
            labelEl.appendChild(priceEl);
            mainBtn.textContent = '';
            mainBtn.appendChild(labelEl);
          } else {
            mainBtn.textContent = soldOutLabel;
          }
        }
        if (stickyBtn) {
          stickyBtn.disabled = !v.available;
          stickyBtn.textContent = v.available ? addLabel : soldOutLabel;
        }
      }

      Array.prototype.forEach.call(mainOptionInputs, function (r) {
        r.addEventListener('change', function () { syncSelectsFromMain(); applyVariant(); });
      });
      Array.prototype.forEach.call(stickyOptionSelects, function (s) {
        s.addEventListener('change', function () {
          var idx = parseInt(s.dataset.pdpOptionIndex, 10);
          Array.prototype.forEach.call(mainOptionInputs, function (r) {
            if (parseInt(r.dataset.pdpOptionIndex, 10) === idx) r.checked = (r.value === s.value);
          });
          applyVariant();
        });
      });

      function setQty(val) {
        var n = Math.max(1, parseInt(val, 10) || 1);
        if (mainQty) mainQty.value = n;
        if (stickyQty) stickyQty.value = n;
      }
      if (mainQty) mainQty.addEventListener('input', function () { setQty(mainQty.value); });
      if (stickyQty) stickyQty.addEventListener('input', function () { setQty(stickyQty.value); });
      if (bar) {
        var sDec = bar.querySelector('[data-pdp-sticky-qty-dec]');
        var sInc = bar.querySelector('[data-pdp-sticky-qty-inc]');
        if (sDec) sDec.addEventListener('click', function () { setQty((parseInt(stickyQty.value, 10) || 1) - 1); });
        if (sInc) sInc.addEventListener('click', function () { setQty((parseInt(stickyQty.value, 10) || 1) + 1); });
      }

      // What the bar hides behind: the "Often bought together" carousel when there is one,
      // otherwise the Add to basket button (or the waitlist block on coming-soon PDPs). Same
      // intent either way — don't shadow the real call to action.
      //
      // The carousel is the anchor because the bar arriving at the top of it was closing off the
      // bottom of the screen at exactly the point the carousel already filled the rest of it, so
      // nothing below was ever visible and the page read as finished. Waiting until the carousel
      // has scrolled by keeps a gap open underneath it.
      //
      // The `|| mainBtn` is load-bearing, not defensive: when a product's OBT metafield is empty
      // the whole carousel is omitted from the DOM, and a null anchor would leave those products
      // with no sticky bar at all and no error to notice it by.
      var stickyAnchor = root.querySelector('.obt') || mainBtn || notifyBlock;
      if (bar && stickyBtn && stickyAnchor) {
        // Shopify Inbox (and similar) chat launchers sit at a near-max z-index, so a plain
        // z-index bump can't beat them without also covering our own cart drawer / lightbox.
        // Instead, lift the chat launcher above the sticky bar while the bar is showing so
        // neither one hides the other. Inline !important is used because Inbox positions its
        // iframe with an inline style that a stylesheet rule can't override.
        function chatLauncher() {
          try {
            // Shopify RENAMED the launcher: <inbox-online-store-chat id="ShopifyChat">
            // became plain <shopify-chat> with no id, so getElementById returns null and
            // the old fallback list missed it too — `#shopify-chat` is an ID selector and
            // never matches the TAG. Match the tag first. (The id-prefix form is still
            // banned: `[id^="shopify-chat"]` grabs the invisible
            // `shopify-chat-bundle-selector` decoy, which sits earlier in the DOM.)
            var el = document.querySelector('shopify-chat, inbox-online-store-chat, #ShopifyChat')
              || document.querySelector('#shopify-chat, iframe[title*="Inbox" i], iframe[title*="chat" i], iframe[src*="shopify-chat"], iframe[src*="inbox"]');
            if (el) {
              var n = el;
              while (n && n !== document.body) {
                if (getComputedStyle(n).position === 'fixed') return n;
                n = n.parentElement;
              }
              return el;
            }
            var boxes = document.querySelectorAll('body iframe, body > div');
            for (var i = 0; i < boxes.length; i++) {
              var s = getComputedStyle(boxes[i]);
              if (s.position === 'fixed' && s.bottom !== 'auto' && parseInt(s.bottom, 10) < 120 && parseInt(s.right, 10) < 160) return boxes[i];
            }
          } catch (e) {}
          return null;
        }
        function syncChat(open, barH) {
          var el = chatLauncher();
          if (!el) return;
          try {
            if (open) {
              if (!el.hasAttribute('data-pdp-prev-bottom')) el.setAttribute('data-pdp-prev-bottom', el.style.bottom || '');
              el.style.setProperty('bottom', ((barH || bar.offsetHeight || 72) + 16) + 'px', 'important');
            } else if (el.hasAttribute('data-pdp-prev-bottom')) {
              var prev = el.getAttribute('data-pdp-prev-bottom');
              if (prev) el.style.setProperty('bottom', prev, 'important'); else el.style.removeProperty('bottom');
              el.removeAttribute('data-pdp-prev-bottom');
            }
          } catch (e) {}
        }

        // A button tucked BEHIND the sticky header is just as invisible to the customer
        // as one scrolled off the top, so the header's height is the real cut-off.
        function headerH() {
          var h = document.querySelector('.shopify-section-group-header-group');
          return h ? h.offsetHeight : 0;
        }

        // `isIntersecting === false` means BOTH "scrolled past it" AND "haven't reached it
        // yet". Under 900px the buy column stacks below the gallery, so the anchor is already
        // out of view at load — the old `!mainVisible` test fired the bar while the customer
        // was still on the first image, before they had ever seen the real price or button.
        // Read the anchor's actual position instead: only "passed" once it sits ABOVE us.
        function anchorPassed() {
          return stickyAnchor.getBoundingClientRect().bottom <= headerH();
        }

        var lastVis = null;
        function applyVisibility() {
          var vis = anchorPassed() && window.scrollY > 200;
          if (vis === lastVis) return;
          lastVis = vis;
          var barH = bar.offsetHeight || 72;
          bar.classList.toggle('is-visible', vis);
          bar.setAttribute('aria-hidden', vis ? 'false' : 'true');
          document.body.classList.toggle('pdp-sticky-open', vis);
          // Lets the toast lift clear of the bar (see body.pdp-sticky-open .toast in theme.css).
          if (vis) document.body.style.setProperty('--pdp-sticky-h', barH + 'px');
          else document.body.style.removeProperty('--pdp-sticky-h');
          syncChat(vis, barH);
        }

        // Scroll fires far faster than the bar can change state, and chatLauncher() walks the
        // DOM with getComputedStyle — so coalesce into one rAF and bail early when unchanged.
        var ticking = false;
        function updateVisibility() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { ticking = false; applyVisibility(); });
        }
        // The observer is no longer the source of truth, just a cheap extra trigger for layout
        // shifts (images finishing load and pushing the anchor) that fire no scroll event.
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function () { updateVisibility(); }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
          io.observe(stickyAnchor);
        }
        window.addEventListener('scroll', updateVisibility, { passive: true });
        window.addEventListener('resize', updateVisibility, { passive: true });

        // The bar's height changes with the breakpoint (under 760px the options and the button
        // wrap onto their own rows), but applyVisibility() bails out when the shown/hidden state
        // is unchanged — so a rotate or a window resize would leave --pdp-sticky-h stale and the
        // footer's bottom clearance (body.pdp-sticky-open .tp-footer in theme.css) short by a row.
        var rsz;
        function remeasureBar() {
          if (!bar.classList.contains('is-visible')) return;
          var h = bar.offsetHeight || 72;
          document.body.style.setProperty('--pdp-sticky-h', h + 'px');
          syncChat(true, h);
        }
        window.addEventListener('resize', function () { clearTimeout(rsz); rsz = setTimeout(remeasureBar, 150); }, { passive: true });

        updateVisibility();

        stickyBtn.addEventListener('click', function () {
          if (!form) { revealNotify(); return; }
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      // ---- Coming-soon waitlist -------------------------------------------------
      function revealNotify() {
        if (!notifyBlock) return;
        notifyBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        notifyBlock.classList.remove('is-flagged');
        void notifyBlock.offsetWidth;              // restart the animation on a repeat click
        notifyBlock.classList.add('is-flagged');
        try { notifyBlock.focus({ preventScroll: true }); } catch (e) { }
      }

      if (notifyBlock) {
        // Product cards link to <product-url>#notify. The browser's own jump lands hard and, on a
        // slow connection, before Omnisend has drawn the form — so take the hash over and scroll
        // once the page has settled.
        if (window.location.hash === '#notify') {
          window.requestAnimationFrame(function () { setTimeout(revealNotify, 120); });
        }

        // Omnisend renders the signup form itself and emits `omnisendForms` on the window for every
        // interaction with it. Hooking that is the only way to know a waitlist signup happened —
        // there is no form of ours to listen to. Product identity comes from our own data attributes,
        // not the event, so the count is attributable even though the form is not ours.
        window.addEventListener('omnisendForms', function (e) {
          var detail = (e && e.detail) || {};
          if (detail.eventType !== 'submit' && detail.type !== 'submit') return;
          if (typeof window.fbq !== 'function') return;   // pixel is injected by the Facebook app, may be absent
          try {
            window.fbq('trackCustom', 'WaitlistSignup', {
              content_name: notifyBlock.getAttribute('data-product-title') || '',
              content_ids: [notifyBlock.getAttribute('data-product-handle') || ''],
              content_type: 'product',
              // coming-soon vs sold-out: only the former is a demand signal for something we have
              // never made. Splitting them here keeps the ranking honest in Events Manager.
              waitlist_kind: notifyBlock.getAttribute('data-waitlist-kind') || ''
            });
          } catch (err) { }
        });
      }

      applyVariant();
    })();
  
})();
